const codigoIbge = {
    Aquiraz: '2301001',
    Caucaia: '2303709',
    Cascavel: '2303501',
    Eusébio: '2304285',
    Fortaleza: '2304400',
    Guaiuba: '2304950',
    Maracanau: '2307650',
    Maranguape: '2307700',
    Pacatuba: '2309602'
};

export const planosDiferenciadosCidadesCeara = [
    codigoIbge.Aquiraz,
    codigoIbge.Caucaia,
    codigoIbge.Cascavel,
    codigoIbge.Eusébio,
    codigoIbge.Fortaleza,
    codigoIbge.Guaiuba,
    codigoIbge.Maracanau,
    codigoIbge.Maranguape,
    codigoIbge.Pacatuba
];